export default __webpack_public_path__ + "media/images/casatb/tenant/diamond-four-1923c1e00c6ad00340f349f50a3dbb3e.png";